<script>
  import { ROUTE_LOG_SCHEME } from '../../scheme'

  import KebabMenu from '../KebabMenu.svelte'
  import RouteLogView from '../../views/RouteLogView.svelte'
  import FireDocForm from './FireDocForm.svelte'
  import RouteLogDeleter from './RouteLogDeleter.svelte'

  export let logs // RouteLog配列
  export let logsRef // RouteLogコレクション リファレンス
  export let date // 日付。新規作成に利用
  export let reporterName // 報告者名。新規作成に利用

  let fireDocForm // コンポーネント保持用
  let routeLogDeleter // コンポーネント保持用

  // 各メニューに対応した操作
  const modifyLog = {
    // 編集
    //  編集フォームを開く
    edit: (log) => fireDocForm.open(log),

    // コピー
    copy: (log) => {
      // 元データからドキュメント リファレンスを除去
      const { ref, ...data } = log
      // コレクション リファレンスとコピーデータでフォームを開く
      fireDocForm.open({ colRef: logsRef, ...data, order: log.order + 1 })
    },

    // 一番下へ
    //  orderに現在時刻を入れることで一番下の順位にする
    bottom: (log) => log.ref.set({ order: Date.now() }, { merge: true }),

    // 削除
    //  削除モーダルを開く
    delete: (log) => routeLogDeleter.open(log),
  }
</script>

<!-- 走行記録のリスト表示 -->
{#each logs as log, index}
  <div
    class="box routeLog"
    data-testid={`routeLogBox${index}`}
    class:has-background-info-light={!(index % 2)}
  >
    <KebabMenu
      name={`log${index}Kebab`}
      on:select={(event) => modifyLog[event.detail.name](log)}
    />
    <RouteLogView name={`routeLog${index}`} {log} />
  </div>
{/each}

<hr />

<!-- 走行記録の新規追加ボタン -->
<button
  class="button"
  data-testid="routeLogAddButton"
  on:click={() =>
    fireDocForm.open({
      colRef: logsRef,
      date,
      reporterName,
      order: Date.now(),
    })}
>
  <span class="icon">
    <i class={`fas fa-plus`} aria-hidden="true" />
  </span><span>走行記録の追加</span>
</button>

<!-- フォームを仕込む -->
<FireDocForm
  name="routeLogForm"
  title="走行記録"
  scheme={ROUTE_LOG_SCHEME}
  bind:this={fireDocForm}
/>

<RouteLogDeleter bind:this={routeLogDeleter} />

<style>
  .box.routeLog {
    position: relative;
  }
</style>
